import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Container, IconButton, Typography } from '@material-ui/core';
import { HighlightOff } from '@material-ui/icons';

import { removeFromCart } from '../../flux/actions/shoppingCart-actions';
import { ProductModel } from '../../models/product-model';
import { useStyles } from './styles';

interface Props {
    cartItems: ProductModel[];
    productError: [];
    checkProductStatus: (id: string) => boolean;
    className?: string;
}

export const CartItems = ({ cartItems, checkProductStatus, productError, className }: Props) => {
    const classes = useStyles();
    const dispatcher = useDispatch();

    const removeFromCartHandler = (id: string) => {
        dispatcher(removeFromCart(id));
    }

    return (
        <div className={className}>
            {
                cartItems.map((product: ProductModel) => (
                    <Container key={product.productCode} className={classes.productsPaper}>
                        <Box className={classes.productsBox}>
                            <Box style={{ display: 'flex', alignItems: 'center' }}>
                                <img 
                                    className={classes.productImage} 
                                    src={product.image} 
                                    alt={product.full_name} 
                                />
                                <Box style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography
                                        style={{ fontWeight: 'bold' }}
                                        className={(checkProductStatus(product.id) && !product.status) ? classes.productNotAvailable : ''}
                                        variant='body2' 
                                    >
                                        {product.full_name}
                                    </Typography>
                                    <Typography
                                        style={{ color: '#D32F2F' }}
                                        className={(checkProductStatus(product.id) && !product.status) ? classes.redColor : ''} 
                                        variant='body2' 
                                    >
                                        {
                                            (checkProductStatus(product.id) && !product.status)
                                                ? 'Agotado'
                                                : `$${product.cost && product.cost.toFixed(2)}`
                                        }
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className={checkProductStatus(product.id) ? classes.redColor : ''}>
                                {
                                    (checkProductStatus(product.id))
                                        ? <Box className={classes.productQtyNoAvailable}>
                                            {productError.filter((productError: any) => productError.id === product.id).map(((product: any) => (
                                                (product.status === 'deleted')
                                                    ? <IconButton onClick={() => removeFromCartHandler(product.id)}>
                                                        <HighlightOff style={{ color: 'white' }} />
                                                    </IconButton>
                                                    : product.new_qty
                                            )))}
                                        </Box>
                                        : <Box className={classes.productQty}>
                                            {product.qty}
                                        </Box>
                                }
                            </Box>
                        </Box>
                    </Container> 
                ))
            }
        </div>
    );
}
